import React, { FC, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAccount, useDisconnect } from 'wagmi';

import { setNativeBalance, setInstrumentPairBalance } from 'store/entities/wallet/slice';
import { ecosystem } from 'utils/smartcontract/isMainnet';

import { communityOptions, needHelpOptions } from './dropdownOptions';

import menuIcon from 'assets/images/menu.svg';
import logoutIcon from 'assets/images/logout.svg';

import './MenuDropdown.scss';

const MenuDropdown: FC = () => {
  const dispatch: any = useDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const boxRef = useRef<HTMLDivElement>(null);

  const { isConnected } = useAccount();
  const { disconnect } = useDisconnect();

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (boxRef.current && !boxRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const helpOptions = needHelpOptions.filter(o => o.ecosystem.includes(ecosystem));

  const onDisconnect = () => {
    disconnect();
    dispatch(setNativeBalance(null));
    dispatch(setInstrumentPairBalance({ baseCurrency: '0', quoteCurrency: '0' }));
  };

  return (
    <div ref={boxRef} className={`menu-dropdown ${isOpen ? 'open' : 'close'}`}>
      <div onClick={() => setIsOpen(!isOpen)} className="header-menu-btn">
        <div className="logo">C</div>
        <img src={menuIcon} alt="menu" />
      </div>

      <div className="select-instruments-list" onClick={() => setIsOpen(!isOpen)}>
        <div className="need-help-group">
          <div className="group-subtitle">{_t('Need help?', 'HEADER.NEED_HELP')}</div>

          {helpOptions.map(option => (
            <a
              key={option.name}
              className="select-instruments-list-inst"
              target="_blank"
              rel="noopener noreferrer"
              href={option.link}
            >
              <img src={option.icon} alt="gitbook" />
              {option.name}
            </a>
          ))}
        </div>

        <div className="community-group">
          <div className="group-subtitle">{_t('Community', 'HEADER.COMM')}</div>

          {communityOptions.map(option => (
            <a
              key={option.name}
              className="select-instruments-list-inst"
              target="_blank"
              rel="noopener noreferrer"
              href={option.link}
            >
              <img src={option.icon} alt="gitbook" />
              {option.name}
            </a>
          ))}
        </div>

        {isConnected && (
          <div className="disconnect-group">
            <div className="select-instruments-list-inst" onClick={onDisconnect}>
              <img src={logoutIcon} alt="disconnect" />
              {_t('Disconnect', 'HEADER.DISCONNECT')}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MenuDropdown;
